import { apiFetch } from '@app/lib/api'
import type { OrderDetailResponse, OrderFilter, OrderListResponse, OrderSort, OrderType } from './types'

/**
 * Typed fetch helpers for the orders module.
 *
 * Uses the shared `apiFetch` wrapper from `lib/api.ts`; module-specific calls
 * stop here so the shared file isn't edited by five modules at once.
 */

export interface OrderListParams {
  query?: string
  status?: OrderFilter
  type?: OrderType | 'all' | 'sales'
  from?: string | null
  to?: string | null
  sort?: OrderSort
  page?: number
  pageSize?: number
}

function toSearch(params: OrderListParams): string {
  const search = new URLSearchParams()
  if (params.query) search.set('query', params.query)
  if (params.status && params.status !== 'all') search.set('status', params.status)
  if (params.type && params.type !== 'all') search.set('type', params.type)
  if (params.from) search.set('from', params.from)
  if (params.to) search.set('to', params.to)
  if (params.sort && params.sort !== 'priority') search.set('sort', params.sort)
  if (params.page && params.page > 1) search.set('page', String(params.page))
  if (params.pageSize) search.set('pageSize', String(params.pageSize))
  const qs = search.toString()
  return qs ? `?${qs}` : ''
}

export const ordersApi = {
  list: (params: OrderListParams) =>
    apiFetch<OrderListResponse>(`/orders${toSearch(params)}`),
  detail: (sipNo: number | string) => apiFetch<OrderDetailResponse>(`/orders/${sipNo}`),
}

export const ordersQueryKeys = {
  all: ['orders'] as const,
  list: (params: OrderListParams) => ['orders', 'list', params] as const,
  detail: (sipNo: number | string) => ['orders', 'detail', String(sipNo)] as const,
}
